/**
 * Admin Users — Saved Views & Features Configuration
 */

export const adminUserSavedViews = [
  {
    id: "active_users",
    name: "Active Users",
    filters: { is_active: true },
    isDefault: false,
  },
  {
    id: "inactive_users",
    name: "Inactive Users",
    filters: { is_active: false },
    isDefault: false,
  },
  {
    id: "admins",
    name: "Admins",
    filters: { role: "wtc_admin" },
    isDefault: false,
  },
  {
    id: "employees",
    name: "Employees",
    filters: { role: "wtc_employee" },
    isDefault: false,
  },
];

export const adminUserFeatures = {
  search: true,
  filters: true,
  export: true,
  bulkActions: true,
  columnResizing: true,
  columnVisibility: true,
  savedViews: true,
  infiniteScroll: false,
  multiColumnSort: true,
};
